import React, { useEffect } from 'react';


import { Description, SubHeader, SubHeadline } from '../../../Components/CustomComponent';
import { useAppContext } from '../../../Context/AppContext';



export default function ShareSupport({ question = {}, options = [] }) {
    const { isWebView } = useAppContext();



    useEffect(() => {
        if (!!isWebView) {
            if (window?.FlutterChannel) {
                window.FlutterChannel.postMessage(JSON.stringify(question));
            }
            else {
            }
        }

    }, [])


    return (
        <>
            {/* {answers?.map(item => {
                return <Button
                    text={item.option}
                    lightTheme={true}
                    classes='fw-bold'
                    disabled={true}
                />
            })}
            {} */}
            <Description
                text='Reach out to your friends for support and assistance.'
                classes='my-4 text-center'
                size='5'
            />
        </>
    )
}
